import {Route} from "router5";
import WebUtil from "platform/util/WebUtil";

export enum RouteType {

    Login = "login",
    ForgotPassword = "forgotPassword",
    HomeScreens = "homeScreens",
    Home = "home",
    AccountOverview = "accountOverview",
    Symbols = "symbols",
    SymbolSearch = "symbolSearch",
    MyTrades = "myTrades",
    Tools = "tools",
    News = "news",
    Article = "article",
    Chart = "chart",
    CreateUpdateTrade = "createUpdateTrade",
    Deal = "deal",
    ClosedDeal = "closedDeal",
    EconomicCalendar = "economicCalendar",
    TradingOpportunities = "tradingOpportunities",
    Lessons = "lessons",
    Promotions = "promotions",
    AccountSettings = "accountSettings",
    Withdrawal = "withdrawal",
    DepositLimits = "depositLimits",
    AlertSymbol = "alertSymbol",
    Filters = "filters",
    CloseTrade = "closeTrade",
    ClosedTrade = "closedTrade",
    Professional = "professional",
    UploadDocument = "uploadDocument",
    Kyc = 'kyc',
    Deposit = "deposit",
}

export class Routes {

    private static COMMON: Route[] = [
        {name: RouteType.AccountOverview, path: "/account-overview"},
        {name: RouteType.Symbols, path: "/symbols"},
        {name: RouteType.MyTrades, path: "/my-trades"},
        {name: RouteType.News, path: "/news"},
        {name: RouteType.EconomicCalendar, path: "/economic-calendar"},
        {name: RouteType.TradingOpportunities, path: "/trading-opportunities"},
        {name: RouteType.Lessons, path: "/lessons?Id"},
        {name: RouteType.Promotions, path: "/promotions"},
        {name: RouteType.AccountSettings, path: "/account-settings"},
        {name: RouteType.Withdrawal, path: "/withdrawal"},
        {name: RouteType.DepositLimits, path: '/deposit-limits'},
    ];

    private static DESKTOP: Route[] = [
        ...Routes.COMMON
    ];

    private static MOBILE: Route[] = [
        ...Routes.COMMON,
        {name: RouteType.SymbolSearch, path: "/symbol-search"},
        {name: RouteType.Chart, path: "/chart?SymbolId"},
        {name: RouteType.Article, path: "/article?Id"},
        {name: RouteType.CreateUpdateTrade, path: "/cu-trade?SymbolId&DealId"},
        {name: RouteType.ClosedDeal, path: "/close-deal?DealId"},
        {name: RouteType.Tools, path: "/tools"},
    ];

    private static NATIVE: Route[] = [
        ...Routes.MOBILE,
        {name: RouteType.Login, path: "/login"},
        {name: RouteType.ForgotPassword, path: "/forgot-password"},
        {name: RouteType.HomeScreens, path: "/home-screens"},
        {name: RouteType.Home, path: "/home"},
        {name: RouteType.CloseTrade, path: "/close-trade"},
        {name: RouteType.ClosedTrade, path: "/closed-trade"},
        {name: RouteType.Professional, path: "/become-a-professional"},
        {name: RouteType.UploadDocument, path:"/upload-documents"},
        {name: RouteType.Kyc, path: "/finalize-registration"},
        {name: RouteType.Deposit, path: "/deposit"}
    ];

    private constructor() {
    }

    public static routes(): Route[] {
        return WebUtil.isMobile() ? Routes.MOBILE : Routes.DESKTOP;
    }

    public static native(): Route[] {
        return  Routes.NATIVE;
    }
}
